import 'babel-polyfill';
import './configure';
import './main.css';
import { loadPolyfills } from './polyfills';

import { getLocalFromLocation } from './url';

loadPolyfills()
  .then(() => {
    return import(
      /* webpackChunkName: "app-main" */
      './bootstrapper'
    );
  })
  .then(async ({ bootstrapApplication }) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    return bootstrapApplication().catch((err) => {
      handleUnexpectedException(err);
    });
  })
  .then(() => {
    // this polyfill is for lazy loading images in older browsers, and is needed
    // even in newer browsers to allow images in noscript tags to show. This polyfill
    // must be loaded after rehydration completes rather than before.
    require('loading-attribute-polyfill');
  });

const handleUnexpectedException = (err: any) => {
  const errorCode: string = err.code ? err.code : 'general';
  const errorPageUrl = buildErrorPageUrl(errorCode);

  globalThis.location.assign(errorPageUrl);
};

const sanitizeLocale = (value: string): string => {
  const locale = String(value || '').trim();
  return /^[A-Za-z]{2}(?:-[A-Za-z]{2})?$/.test(locale) ? locale : 'en-US';
};

const sanitizeErrorCode = (value: string): string => {
  const code = String(value || '')
    .trim()
    .replace(/[^A-Za-z0-9_-]/g, '');
  return code || 'general';
};

export const buildErrorPageUrl = (errorCode: string): string => {
  const localRaw = getLocalFromLocation(globalThis.location);
  const local = sanitizeLocale(localRaw);
  const safeCode = sanitizeErrorCode(errorCode);
  const url = new URL(
    `/${local}/errors/${safeCode}.html`,
    globalThis.location.origin
  );
  return url.toString();
};
